const colorsArray = [
	"rgb(64, 0, 0)",
	"rgb(96, 0, 0)",
	"rgb(128, 0, 0)",
	"rgb(160, 0, 0)",
	"rgb(192, 0, 0)",
	"rgb(224, 0, 0)",
	"rgb(255, 0, 0)",
	"rgb(255, 32, 0)",
	"rgb(255, 64, 0)",
	"rgb(255, 96, 0)",
	"rgb(255, 128, 0)",
	"rgb(255, 160, 0)",
	"rgb(255, 192, 0)",
	"rgb(255, 224, 0)",
	"rgb(255, 255, 0)",
	"rgb(224, 255, 0)",
	"rgb(192, 255, 0)",
	"rgb(160, 255, 0)",
	"rgb(128, 255, 0)",
	"rgb(96, 255, 0)",
	"rgb(64, 255, 0)",
	/*"rgb(32, 255, 0),*/
	"rgb(0, 255, 0)",
	/*"rgb(0, 255, 32)",*/
	"rgb(0, 255, 64)",
	"rgb(0, 255, 96)",
	"rgb(0, 255, 128)",
	"rgb(0, 255, 160)",
	"rgb(0, 255, 192)",
	"rgb(0, 255, 224)",
	"rgb(0, 255, 255)",
	"rgb(0, 224, 255)",
	"rgb(0, 192, 255)",
	"rgb(0, 160, 255)",
	"rgb(0, 128, 255)",
	"rgb(0, 96, 255)",
	"rgb(0, 64, 255)",
	"rgb(0, 32, 255)",
	"rgb(0, 0, 255)",
	"rgb(0, 0, 224)",
	"rgb(0, 0, 192)",
	"rgb(0, 0, 160)",
	"rgb(0, 0, 128)",
	"rgb(0, 0, 96)",
	"rgb(0, 0, 64)",
];


const activityLevel = {
	"none": "rgba(255, 255, 255, 0.5)",
	"low": "rgba(0, 255, 0, 0.5)",
	"medium": "rgba(255, 165, 0, 0.5)",
	"high": "rgba(255, 0, 0, 0.5)",
	"default": "rgba(0, 0, 0, 0.5)"
};

const activityEdge = "rgb(128, 128, 128)";


export default {
	pointOffset: colorsArray,
	activityLevel: activityLevel,
	activityEdge: activityEdge
};
